import { render } from "./ContractorAccount.vue?vue&type=template&id=a055524e"
import script from "./ContractorAccount.vue?vue&type=script&lang=js"
export * from "./ContractorAccount.vue?vue&type=script&lang=js"

import "./ContractorAccount.vue?vue&type=style&index=0&id=a055524e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__